import { isStandalone } from './pwa.js';

// The installed app on a touch screen doesn't zoom, like a native app (owner request 01/11/2026, after OdeParfum's, proven
// on a real iPhone there). A browser tab and a computer's installed window keep it: there it's how people read small text.
// Three locks, since none holds everywhere: the viewport tag and touch-action stop Chrome's pinch, touch-action also stops
// the double tap, and iOS has its own gesture events. No touchmove listener: a blocking one on the document would make
// every scroll wait for the page.

export const LOCKED_VIEWPORT = 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no';
export const LOCKED_TOUCH_ACTION = 'pan-x pan-y';
const IOS_GESTURES = ['gesturestart', 'gesturechange', 'gestureend'];

const touchScreen = (win) => {
  try {
    return win.matchMedia?.('(hover: none) and (pointer: coarse)').matches === true;
  } catch {
    return false;
  }
};

export const installAppZoomLock = (win = window) => {
  if (!isStandalone(win) || !touchScreen(win)) return;
  const doc = win.document;
  doc.querySelector('meta[name="viewport"]')?.setAttribute('content', LOCKED_VIEWPORT);
  doc.documentElement.style.touchAction = LOCKED_TOUCH_ACTION;
  const stop = (event) => event.preventDefault();
  IOS_GESTURES.forEach((type) => doc.addEventListener(type, stop, { passive: false }));
};
